// @flow
import * as React from 'react';
import {Link} from 'react-router-dom';
import {makeStyles, Tooltip, Typography} from '@material-ui/core';
import {InfoOutlined} from '@material-ui/icons';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';
import inviteFriends from '../../../../assets/img/invite-referral.png';

import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {PropTypes} from 'prop-types';

import {connect} from 'react-redux';

import type {RootState} from '../../../index';
import type {Store} from '../../../../entities';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
  }),
  null
)(ReferralModal);

type Props = {|
  store?: Store,
  open: boolean,
  handleCloseModal: () => void,
|};

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4, 4, 1, 4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4, 0, 1, 0),
    },
    maxWidth: 440,
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '18px',
  },
  subtitle: {
    textAlign: 'center',
    marginTop: theme.spacing(1),
    color: '#3A3A49',
  },
  content: {
    marginTop: theme.spacing(2),
    borderRadius: '12px',
    paddingBottom: theme.spacing(2),
    maxWidth: 440,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '80%',
      margin: '0 auto',
    },
  },
  closeButton: {
    backgroundColor: '#FFDF65',
    fontSize: '1rem',
    width: 240,
    height: 48,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#FFDF65!important',
    },
  },
  containerTable: {
    margin: '1rem 0',
    width: '100%',
    borderRadius: '10px',
    border: '1px solid #E9E9EC',
    flexDirection: 'column',
  },
  subTitle: {
    color: '#3A3A49',
    fontWeight: 600,
    fontSize: '18px',
  },
  secondaryText: {
    marginTop: theme.spacing(2),
    fontSize: '12px',
    fontWeight: '700',
  },
  rowPoints: {
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    '&:nth-child(2n+1)': {
      backgroundColor: '#F9F9FB',
    },
  },
  text: {
    color: '#353640',
    fontSize: '11px',
    fontWeight: 500,
  },
  wrapperTable: {
    padding: theme.spacing(2),
    margin: theme.spacing(2, 0),
    background: '#F8F5FF',
    boxShadow:
      '0px 0px 0.733333px rgba(40, 41, 61, 0.08), 0px 0.366667px 1.46667px rgba(96, 97, 112, 0.16)',
    borderRadius: '6px',
  },
  imgInvite: {
    width: '5rem',
    margin: '0.5rem auto',
  },
  wrapperTitle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  infoTooltip: {
    color: colors.purple3,
    backgroundColor: colors.lightPurple,
    borderRadius: '8px',
    textAlign: 'center',
    maxWidth: 240,
  },
  infoIcon: {
    color: '#B8B8C7',
  },
  tooltipText: {
    color: '#7B39FF',
    fontSize: '12px',
    margin: theme.spacing(1, 0, 1, 0),
    letterSpacing: '0.005em',
    textAlign: 'left',
    fontWeight: 500,
  },
  textBg: {
    backgroundColor: '#7B39FF',
    color: '#FFFFFF',
    padding: '0 5px',
  },
  mediumText: {
    fontWeight: 500,
  },
  boldText: {
    fontWeight: 700,
  },
}));

function ReferralModal(props: Props) {
  const {open, handleCloseModal} = props;

  // const history = useHistory();
  const classes = useStyles();

  const tablePoints = [
    {
      label: 'Sube primer producto',
      points: '1',
    },
    {
      label: 'Genera su primera venta',
      points: '5',
    },
    {
      label: 'Se suscribe a Pro',
      points: '40',
    },
  ];

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Typography className={classes.title}>
          Ayuda a tus amigos a conocer TiendaDa e impulsar sus emprendimientos.
        </Typography>
        <Typography className={classes.subtitle}>
          Y tú,{' '}
          <span className={classes.textBg}>
            <span className={classes.boldText}>GANA</span> puntos
          </span>{' '}
          para obtener funcionalidades{' '}
          <span className={classes.mediumText}>PRO</span> y aumentar tus ventas.
        </Typography>
        <div className={classes.content}>
          <img
            src={inviteFriends}
            alt="invite friend"
            className={classes.imgInvite}
          />
          <div className={classes.wrapperTable}>
            <div className={classes.wrapperTitle}>
              <Typography className={classes.subTitle}>
                Tabla de puntos
              </Typography>
              <Tooltip
                classes={{tooltip: classes.infoTooltip}}
                placement="left-start"
                title={
                  <div className={classes.tooltipContainer}>
                    <Typography className={classes.tooltipText}>
                      Gana 1 punto si tu referido consigue subir su primer
                      producto.
                    </Typography>
                    <Typography className={classes.tooltipText}>
                      Gana 5 puntos si tu referido realiza su primera venta.
                    </Typography>
                    <Typography className={classes.tooltipText}>
                      Gana 40 puntos si tu referido se suscribe a PRO +.
                    </Typography>
                  </div>
                }
              >
                <InfoOutlined color="primary" className={classes.infoIcon} />
              </Tooltip>
            </div>
            <Typography className={classes.secondaryText}>
              Tu referido:
            </Typography>
            <div className={classes.containerTable}>
              {tablePoints.map(desc => (
                <div key={`${desc.label}`} className={classes.rowPoints}>
                  <Typography className={classes.text}>{desc.label}</Typography>
                  <Typography className={classes.text}>
                    {desc.points} punto{Number(desc.points) > 1 ? 's' : ''}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        </div>

        <CustomButton
          className={classes.closeButton}
          color="primary"
          component={Link}
          to="/profile/referral"
          onClick={handleCloseModal}
        >
          ¡Empieza ya!
        </CustomButton>
      </div>
    </CustomModal>
  );
}

ReferralModal.propTypes = {
  store: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};
